<template lang="pug">
  .container
    .row
      .login.col-lg-5.col-md-6.col-sm-8.col-xs-10.col-centered.clearfix
        .title
          span(style="color:#ffd700" v-if="domain === 'localhost'") Local
          span(style="color:#44ac35" v-if="domain === 'lantechcom.io'") Lantech
          span(style="color:#c22" v-if="domain === 'intrihub.io'") Intri
          span Hub
        .content
          section.input_group
            .input_single.clearfix
                label Account
                input.input.form-control(type='email',name='acc',placeholder="Enter your account" v-model="account")
            .input_single.clearfix
                label Password
                input.input.form-control(type='password',name='pwd',placeholder="Enter your password" v-model="password" v-on:keyup.enter="login")
          section.func_group.clearfix.row_space--xxs
            //- .social_btn_group.col-md-6.clearfix
            //-   button.btn.btn-social(disabled)
            //-     i.fa.fa-facebook(aria-hidden="true")
            //-   button.btn.btn-social(disabled)
            //-     i.fa.fa-google(aria-hidden="true")

            a.btn.login-btn.btn-primary.col-md-12.clearfix(@click="login") Login
          footer.footer.col-md-12
            //- a.btn.btn-no-bg.col-md-6.col-sm-6.col-xs-12.clearfix(@click='showNewAccount = true') Create new account
            a.btn.btn-no-bg.col-md-12.col-sm-12.col-xs-12.clearfix(@click='showForgetPw = true') Forgot password
      modal(
        title="Please check your email box"
        v-bind:show.sync="showMailHint"
        effect="fade"
        cancel-text="Cancel"
        ok-text="I see")
        .modal-body(slot='modal-body').clearfix
          .col-md-12
            h2 One more step to go....
            p We will send a confirm email to your email box shortly, please check it to activate your account.
        .modal-footer(slot='modal-footer').clearfix
          button.btn.btn-primary(v-on:click='closeDialogs') I see
      modal(
        title="Oops, seems like your Email has not been verified."
        v-bind:show.sync="showMailResend"
        effect="fade"
        cancel-text="Cancel"
        ok-text="I see")
        .modal-body(slot='modal-body').clearfix
          .col-md-12
            h2 Please check your email box .
            p Or We can send the confirm email again.
        .modal-footer(slot='modal-footer').clearfix
          button.btn.btn-primary(v-on:click='resendMail') Send Again
          button.btn.btn-primary(v-on:click='closeDialogs') I see
      modal.new_account_modal(
        title='Creat new account'
        v-bind:show.sync='showNewAccount'
        effect='fade'
        cancel-text="Cancel"
        ok-text="Apply"
        v-bind:callback="handleNewAccount")
        .modal-body(slot='modal-body').clearfix
          //- validator(name="newAccValidator")
            .col-md-8
              label Enter an available email as account
              input.form-control(type='email' v-model='newUser.email' placeholder='example@gmail....' v-validate:newEmail="['email']")
              span.error(v-show='$newAccValidator.newemail.invalid && $newAccValidator.newemail.modified')
                |Please enter a valid email address
            .col-md-8
              label Please enter your password
              input.form-control(type='password' v-model='newUser.pwd' placeholder='1234XXX' maxlength='15')
            .col-md-8
              label Please enter your password again
              input.form-control(type='password' v-model='newUser.confirmPwd' placeholder='please enter your password again' maxlength='15')
      modal.forget_pwd_modal(
        title="Forgot your password"
        v-bind:show.sync='showForgetPw'
        effect='fade')
        .modal-body(slot='modal-body').clearfix
          validator(name="forgetPw")
            .col-md-8
              label Enter your accout/email
              input.form-control(type='email' v-model='forgottenMail' placeholder='please enter your account/email.' v-validate:email="['email']")
              span.error(v-show='$forgetPw.email.invalid && $forgetPw.email.modified')
                | Please enter a valid email address
        .modal-footer(slot='modal-footer').clearfix
          button.btn.btn-primary(v-on:click='handleForget' v-bind:disabled="$forgetPw.email.invalid") Send
</template>

<script>
  import * as Service from 'src/index.js'
  import { modal } from 'vue-strap'
  const domain = window.location.hostname

  export default {
    components: {
      modal
    },
    data: () => ({
      domain,
      account: process.env.NODE_ENV === 'production' ? '' : 'martin@intrising.com.tw',
      password: process.env.NODE_ENV === 'production' ? '' : 'intrising',
      newUser: {
        email: '',
        pwd: '',
        confirmPwd: ''
      },
      forgottenMail: '',
      showNewAccount: false,
      showForgetPw: false,
      showMailHint: false,
      showMailResend: false,
      emailResendTarget: null
    }),
    vuex: {
      getters: {
        user: state => state.user
      }
    },
    methods: {
      alert (type, title, content) {
        this.$dispatch('alert', {
          type: type,
          title: title,
          content: content
        })
      },
      async login () {
        try {
          await Service.login(this.account, this.password)
          // Wait until user role is set in Vuex
          const waitForUser = () => new Promise(resolve => {
            const check = () => {
              if (this.user && this.user.role) {
                resolve()
              } else {
                setTimeout(check, 50)
              }
            }
            check()
          })
          await waitForUser()

          if (this.user.role === "manufacturer") {
            this.$router.replace('/mt-download')
          } else {
            this.$router.replace('/products')
          }
        } catch (err) {
          // console.log(err)
          this.alert('danger', 'Login Fail', err)
        }
      },
      // ========= for create new account ===========
      resendMail () {
        this.emailResendTarget.sendEmailVerification()
        this.showMailResend = false
      },
      closeDialogs () {
        this.showMailHint = false
        this.showMailResend = false
      },
      handleNewAccount () {
        if (this.$newAccValidator.newemail.valid) {
        // this.$newAccValidator.newemail.valid is generated by vue-validator
          if (this.newUser.pwd !== this.newUser.confirmPwd) {
            this.alert('danger', 'Error', 'Two passwords must be same.')
          } else {
            Service.createUser(this.newUser.email, this.newUser.pwd)
            .then(userCredential => {
              // console.log(userCredential)
              userCredential.sendEmailVerification()
              this.account = this.newUser.email
              this.password = ''
              this.showNewAccount = false
              this.showMailHint = true
            })
            .catch(err => {
              this.alert('danger', 'Error', err.message)
            })
          }
        } else {
          this.alert('danger', 'Error', 'Please enter a valid email address')
        }
      },
      // ========= for forget pwd ===================
      handleForget () {
        if (this.$forgetPw.email.valid) {
          Service.resetPassword(this.forgottenMail)
          .then(res => {
            // console.log(res)
            this.showForgetPw = false
            this.alert('success', '', 'Your password has been reset successfully. Please check your email for more detail.')
          })
          .catch(err => {
            // console.log(err)
            this.alert('danger', 'Error', err)
          })
        } else {
          return this.alert('danger', 'Error', 'Please enter a valid email address')
        }
      }
    },
    watch: {
      showNewAccount (show) {
        if (show) {
          this.newUser.email = ''
          this.newUser.pwd = ''
          this.newUser.confirmPwd = ''
        }
      },
      showForgetPw (show) {
        if (show) {
          this.forgottenMail = ''
        }
      }
    },
    ready () {
      // console.log('ready')
    }
  }
</script>

<style lang="scss" scoped>
  body{
    position: relative;
  }
  // ======= login =====
  .login{
    position: absolute;
    margin:auto;
    top:0px;
    bottom: 0px;
    left: 0;
    max-height:250px;
    right: 0;
    .title {
      font-size: 32px;
      text-align: center;
    }
    .content {
      height: 100%;
      padding: 10px 15px;
      box-shadow: 0px 2px 2px #aaa;
      border: 1px solid #eee;
    }
    // border-radius:$base_border_radius;
    // @include breakpoint(sm) {
    //   max-height:300px;
    // }
    // @include breakpoint(xxs) {
    //   max-height:340px;
    // }
  }
   // ====== Btn =======
  .btn{
    font-size: 18px;
  }
  .btn-no-bg{
    color:#aaa;
    &:hover{
      // color:$base_gray;
      text-decoration:underline;
    }
    &.disable{
      opacity:.3;
      text-decoration:none;
      outline:none;
      color:#aaa;
      &:active{
        box-shadow:none;
      }
    }
  }
  // .btn-no-bg:first-child{
  //
  //   border-right:1px solid #aaa;
  //   border-radius:0;
  //   @media screen and (max-width:767px){
  //     border-bottom:1px solid #aaa;
  //     border-right:0px ;
  //   }
  // }
  .func_group{
    padding:10px 5px;
  }
  .social_btn_group{
    margin-bottom: 10px;
    opacity:.3;
  }
  .btn-social{
    width: 30px;
    height: 30px;
    line-height:18px;
    margin:0px 10px;
    box-sizing:border-box;
    border-radius:50%;
    box-shadow:0px 0px 5px #aaa;
    padding:5px;
    background-color:#eee;
  }
   // ====== Input =======

  .input{
    padding:5px 10px;
    margin-bottom: 5px;
  }
  // ====== footer =======

</style>



// WEBPACK FOOTER //
// Login.vue?16ed21b8